import { render, staticRenderFns } from "./featuresettings.vue?vue&type=template&id=b38a879a&scoped=true"
import script from "./featuresettings.vue?vue&type=script&lang=js"
export * from "./featuresettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38a879a",
  null
  
)

export default component.exports